
//--- 1 - localhost, 2 - development, 3 - production
let appMode = "3"

module.exports = appMode